import { forwardRef } from 'react';
import { Button as AntButton, type ButtonProps as AntButtonProps } from 'antd';
import { useFela } from 'react-fela';

import type theme from '@/styles/theme';

import { ButtonType, container, link, text } from './Button.rules';

enum ButtonHTMLType {
    BUTTON = 'button',
    SUBMIT = 'submit',
    RESET = 'reset',
}

export { ButtonHTMLType, ButtonType };

export interface ButtonProps extends Omit<AntButtonProps, 'color'> {
    color?: keyof typeof theme.colors;
    inheritColor?: boolean;
    underline?: boolean;
    customStyle?: typeof container;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ type, htmlType = ButtonHTMLType.BUTTON, color = 'blue', className = '', customStyle, inheritColor, underline, ...props }, ref) => {
        const { css } = useFela({
            color,
            inheritColor,
            underline,
        });

        const finalClassName = `Button Button-${type} ${css(
            type === ButtonType.LINK ? link : type === ButtonType.TEXT ? text : container,
            customStyle,
        )} ${className}`;

        return (
            <AntButton
                {...props}
                ref={ref}
                type={type}
                htmlType={htmlType}
                shape={type === ButtonType.LINK || type === ButtonType.TEXT ? 'default' : 'round'}
                className={finalClassName}
                data-testid={props['data-testid']}
            />
        );
    },
);
